var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FC5050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 5h18",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC5050",
    fillRule: "evenodd",
    d: "M7.293 2.293A1 1 0 0 1 8 2h4a1 1 0 0 1 1 1v1h2V3a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v1h2V3a1 1 0 0 1 .293-.707ZM18 6h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2v13a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d6d5de5df1b680d0c0c849d88e061916.svg";
export { ForwardRef as ReactComponent };